// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-chart-2 {
    text-decoration: none;
    font-size: 13px;
    background-color: #c3c6c9;
    border: 1px solid #a3a7aa;
    text-decoration: none;
    display: flex;
    align-items: center;
    height: 100%;
    cursor: pointer;
    padding: 5px;
}

a:-webkit-any-link {
  text-decoration: none;
  cursor: pointer;
}
.download-button{
  font-size: 13px;
	color: #73879c;
	background-color: transparent;
	text-decoration: none;
	display: flex;
  justify-content: space-between;
	align-items: center;
	height: 100%;
	padding: 5px;
  margin-right: 25px;
}
.button-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.btn-green {
  display: flex;
  align-items: center;
  gap: 5px;
  background-color: #28a745;
  color: white;
  font-weight: bold;
  padding: 10px 20px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
}

.btn-green:hover {
  background-color: #218838;
}

.btn-blue {
  display: flex;
  align-items: center;
  gap: 5px;
  background-color: #007bff;
  color: white;
  font-weight: bold;
  padding: 10px 20px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
}

.btn-blue:hover {
  background-color: #0069d9;
}
`, "",{"version":3,"sources":["webpack://./src/components/Reports/Report.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,YAAY;AAChB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,eAAe;CAChB,cAAc;CACd,6BAA6B;CAC7B,qBAAqB;CACrB,aAAa;EACZ,8BAA8B;CAC/B,mBAAmB;CACnB,YAAY;CACZ,YAAY;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".icon-chart-2 {\n    text-decoration: none;\n    font-size: 13px;\n    background-color: #c3c6c9;\n    border: 1px solid #a3a7aa;\n    text-decoration: none;\n    display: flex;\n    align-items: center;\n    height: 100%;\n    cursor: pointer;\n    padding: 5px;\n}\n\na:-webkit-any-link {\n  text-decoration: none;\n  cursor: pointer;\n}\n.download-button{\n  font-size: 13px;\n\tcolor: #73879c;\n\tbackground-color: transparent;\n\ttext-decoration: none;\n\tdisplay: flex;\n  justify-content: space-between;\n\talign-items: center;\n\theight: 100%;\n\tpadding: 5px;\n  margin-right: 25px;\n}\n.button-container {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.btn-green {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  background-color: #28a745;\n  color: white;\n  font-weight: bold;\n  padding: 10px 20px;\n  border-radius: 5px;\n  border: none;\n  cursor: pointer;\n}\n\n.btn-green:hover {\n  background-color: #218838;\n}\n\n.btn-blue {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  background-color: #007bff;\n  color: white;\n  font-weight: bold;\n  padding: 10px 20px;\n  border-radius: 5px;\n  border: none;\n  cursor: pointer;\n}\n\n.btn-blue:hover {\n  background-color: #0069d9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
